exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tabListbox .wh_content {\n  padding-bottom: 0.5rem;\n}\n.tabListbox .wh_indicator {\n  bottom: -0.05rem;\n}\n.tabListbox .wh_indicator_item {\n  width: 0.2rem;\n  height: 0.2rem;\n  margin: 0.05rem 0.2rem;\n  background: #D4D4D4;\n}\n.tabListbox .wh_show_bgcolor {\n  width: 0.8rem;\n  height: 0.2rem;\n  background: #00AB84;\n  border-radius: 0.15rem;\n}", ""]);

// exports
